// extracted by mini-css-extract-plugin
module.exports = {"onClickWrapper":"Drawer_onClickWrapper__211ed","drawerStyle":"Drawer_drawerStyle__fc357"};